var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDfinityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 406.5,
    viewBox: "0 0 800 406.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#29abe2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.61,
    y1: 795.77,
    x2: 10.68,
    y2: 792.46,
    gradientTransform: "matrix(60.08, 0, 0, -47.2, 101.92, 37853.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fbb03b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4.3,
    y1: 791.43,
    x2: 0.24,
    y2: 794.73,
    gradientTransform: "matrix(60.09, 0, 0, -47.23, 41.93, 37886.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ed1e79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#522785"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M697.7,400A106.44,106.44,0,0,0,590,294.88c-15.72,0-43.51,7.83-85.8,44.87a564.64,564.64,0,0,0-56.27,58.43c23.24,24.65,48.14,50.42,59.54,60.22a325.61,325.61,0,0,0,72.05,45.18A48.08,48.08,0,0,0,590,504.93C649.25,504.75,697.7,457.6,697.7,400Z",
    transform: "translate(0 -196.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-1",
    d: "M506.14,459.82c35.07,30.44,58.61,40.61,73.34,43.88A48.09,48.09,0,0,0,590,505.06c59.6-.37,107.74-47.52,107.74-105.15A106.44,106.44,0,0,0,590,294.82c-15.72,0-43.51,7.83-85.8,44.87a565.24,565.24,0,0,0-56.27,58.49,604.85,604.85,0,0,0,58.25,61.64Z",
    transform: "translate(0 -196.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-2",
    d: "M590,225.6c-41.23,0-86.29,21.33-133.93,62.87a550.21,550.21,0,0,0-56.34,57.81h0s23.24,25.21,48.82,52.09a527.18,527.18,0,0,1,56-58.62c42.22-37,70.08-44.87,85.8-44.87A106.45,106.45,0,0,1,698,400c0,57.63-48.51,104.78-107.74,105.15a47.49,47.49,0,0,1-10.48-1.36,138.56,138.56,0,0,0,53.69,12.76c109,0,130.29-71,131.65-76.24A167,167,0,0,0,770,399.66C769.5,303.69,688.89,225.6,590,225.6Z",
    transform: "translate(0 -196.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-1",
    d: "M102.05,400A106.52,106.52,0,0,0,209.79,505.12c15.72,0,43.58-7.89,85.8-44.87a564,564,0,0,0,56.33-58.62c-23.23-24.65-48.13-50.48-59.6-60.28a323.82,323.82,0,0,0-72-45.18,47.41,47.41,0,0,0-10.48-1.29C150.19,295.5,102.05,342.71,102.05,400Z",
    transform: "translate(0 -196.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-1",
    d: "M293.31,340.37c-35.07-30.45-58.62-40.62-73.35-43.89a47.41,47.41,0,0,0-10.48-1.29,105.15,105.15,0,1,0,0,210.24c15.72,0,43.52-7.89,85.8-44.87a572.39,572.39,0,0,0,56.34-58.62,6.46,6.46,0,0,0,1-1.29,592,592,0,0,0-59.29-60.28Z",
    transform: "translate(0 -196.75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-3",
    d: "M209.79,574.83c41.3,0,86.29-21.27,133.94-62.87A544.64,544.64,0,0,0,400.37,454h0s-23.24-25.21-48.75-52.08a535.19,535.19,0,0,1-56.34,58.62c-42.28,37-70.08,44.87-85.8,44.87A106.45,106.45,0,0,1,101.74,400.28c0-57.63,48.45-104.78,107.74-105.09A47.41,47.41,0,0,1,220,296.48a139.21,139.21,0,0,0-53.74-12.76c-108.67,0-130,70.76-131.29,76A166.49,166.49,0,0,0,30,400.28C29.88,496.24,110.56,574.83,209.79,574.83Z",
    transform: "translate(0 -196.75)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    className: "cls-4",
    d: "M632.86,514.92c-55.47-1.3-113.6-45.18-125.43-56.34C477,430.42,406.29,353.8,401.05,347.64,349.27,290,279.19,225.17,210,225.17h0c-84.81.68-156.19,57.63-174.86,134.3,1.29-4.93,29.15-77.29,131.65-75,55.47,1.3,114,45.86,125.74,57C323,369.58,393.71,446.19,399,452.36,450.66,510,520.44,574.83,590,574.83h0A179.79,179.79,0,0,0,764.57,440.89C763.34,445.52,735.05,517.51,632.86,514.92Z",
    transform: "translate(0 -196.75)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 800,
    height: 406.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfinityLogo);
export default __webpack_public_path__ + "static/media/dfinity-logo.5ba11b57.svg";
export { ForwardRef as ReactComponent };